// Matomo
var _paq = window._paq = window._paq || [];

// désactiver sendBeacon (bypass $ping)
//_paq.push(['disableBeacon']);

/* tracker methods like "setCustomDimension" should be called before "trackPageView" */
_paq.push(['trackPageView']);
_paq.push(['enableLinkTracking']);

(function() {
var u="https://core.rocarosa.net/";
_paq.push(['setTrackerUrl', u+'rocarosa.php?mtm=']);
_paq.push(['setSiteId', '4']);

var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
g.async=true; g.src=u+'rocarosa.js'; s.parentNode.insertBefore(g,s);
})();
